import { Link, useNavigate } from "react-router-dom";
import LangToggle from "./LangToggle";
import { useLang } from "@/i18n/LangContext";
import { useAuth } from "@/lib/AuthContext";

export default function Header({ variant = "landing" }) {
  const { t } = useLang();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      data-testid="site-header"
      className="w-full border-b border-[var(--border)] bg-[var(--bg)] sticky top-0 z-30 backdrop-blur"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between h-[72px]">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
          <span className="font-display text-2xl tracking-tight">Mordomo</span>
          <span className="hidden md:inline label-cap">— ao seu dispor</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {variant === "landing" && (
            <>
              <a href="#manifesto" className="label-cap hover:text-[var(--ink)]" data-testid="nav-manifesto">
                {t("nav.manifesto")}
              </a>
              <a href="#domains" className="label-cap hover:text-[var(--ink)]" data-testid="nav-domains">
                {t("nav.domains")}
              </a>
              <a href="#pricing" className="label-cap hover:text-[var(--ink)]" data-testid="nav-pricing">
                {t("nav.pricing")}
              </a>
            </>
          )}
        </nav>

        <div className="flex items-center gap-6">
          <LangToggle />
          {user && user.id ? (
            <>
              <Link
                to="/app"
                className="label-cap hover:text-[var(--ink)] hidden md:inline"
                data-testid="header-app-link"
              >
                {t("app.sidebar.dashboard")}
              </Link>
              <button
                className="btn-ghost"
                onClick={async () => {
                  await logout();
                  navigate("/");
                }}
                data-testid="header-logout-btn"
              >
                {t("nav.logout")}
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="label-cap hover:text-[var(--ink)]" data-testid="header-login-link">
                {t("nav.enter")}
              </Link>
              <Link to="/register" className="btn-primary" data-testid="header-begin-btn">
                {t("nav.begin")}
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
